webpackJsonp([1],{

/***/ 1000:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "//www.liveinternet.ru/click",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "//counter.yadro.ru/logo?44.6",
      "title": "LiveInternet",
      "alt": "",
      "border": "0",
      "width": "31",
      "height": "31"
    }
  })])
}]}

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ad-block",
    attrs: {
      "id": "contema_acg"
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Цель нашего проекта — экономия времени исследователей, аспирантов и студентов при формировании списка источников научной статьи, дипломоной работы или диссертации.\n        Такие ресурсы, как E-Library.ru, содержат полную библиографическую информацию о статьи.\n        Но увы, оформление этой информации в соответствии с требованиями ГОСТ может занять очень много времени.\n        Наша система берет данные статьи из E-library, форматирует их в соовтетствии с шаблоном, отвечающим требованиям ГОСТ.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Современному исследователю часто приходится давать ссылки на материалы сети Интернет, не оформленные в виде научной статьи. Подобные ссылки оформляются в соответствии с ГОСТ весьма неочевидным способом. Для упрощения форматирования таких ссылок у нас предусмотрен пункт «Ссылка на электронный ресурс». С сожалению, не представляется возможным автоматически определить имя автора публикации. Поэтому, если вы знаете имя автора, укажите его, нажав кнопку «Дополнительно».\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_vm._v("\n      В будущем мы предполагаем развить данный проект в полноценный редактор научных статей, который помимо ссылок будет упрощать и оформления самих статей. Вы можете ознакомиться с пробной версией редактора на соответствующей "), _c('router-link', {
    attrs: {
      "to": {
        name: 'editor'
      }
    }
  }, [_vm._v("странице")]), _vm._v(".\n    ")], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\n        ArtJump — автоматический генератор ссылок по ГОСТ онлайн\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [_vm._v("\n      Если вы заметили неточность, либо просто хотите поделиться мыслями и предложениями по развитию проекта, вы можете оставить отзыв на соответствующей "), _c('a', {
    attrs: {
      "href": "http://art-jump.reformal.ru/proj/"
    }
  }, [_vm._v("странице")]), _vm._v(".\n    ")])
}]}

/***/ }),

/***/ 1003:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('form', {
    ref: "form",
    attrs: {
      "method": "POST",
      "action": "/api/export.php",
      "target": "_blank"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "name": "format"
    },
    domProps: {
      "value": _vm.format
    }
  }), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "content"
    },
    domProps: {
      "value": _vm.contentWithSource
    }
  })]), _vm._v(" "), (_vm.formatSources) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "sources"
  }, _vm._l((_vm.orderedSources), function(item) {
    return _c('lit-list-item-view', {
      key: item.id,
      attrs: {
        "content": item.content,
        "label": item.label
      }
    })
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editor"
  }, [_c('link-generator', {
    ref: "generator"
  }), _vm._v(" "), _c('base-editor', {
    ref: "editor",
    attrs: {
      "value": _vm.contentFullHtml
    },
    on: {
      "input": _vm.onInput,
      "click": _vm.onContentClick,
      "keydown": _vm.onKeyDown
    }
  }, [_c('div', {
    staticClass: "header",
    attrs: {
      "slot": "pre-content"
    },
    slot: "pre-content"
  }, [_c('div', {
    staticClass: "udc"
  }, [_vm._v("\n        УДК 000\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "footer",
    attrs: {
      "slot": "post-content"
    },
    slot: "post-content"
  }, [_vm._t("lit-list")], 2)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source-dialog-header"
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "value": _vm.value.url,
      "disabled": _vm.disabled,
      "placeholder": "Укажите ссылку на статью в elibrary или ссылку на электронный ресурс"
    },
    on: {
      "input": function($event) {
        _vm.setValue('url', arguments[0])
      }
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary load-source",
    attrs: {
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onLoadSource($event)
      }
    }
  }, [_vm._v("\n      Загрузить данные\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "type-select"
  }, _vm._l((_vm.typeOptions), function(option) {
    return _c('md-radio', {
      key: option.key,
      attrs: {
        "value": _vm.value.type,
        "md-value": option.key,
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          _vm.setValue('type', arguments[0])
        }
      }
    }, [_vm._v(_vm._s(option.title))])
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1006:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('source-dialog-view', {
    ref: "dialogView",
    attrs: {
      "content": _vm.content,
      "action": _vm.action
    },
    on: {
      "set-content": _vm.setContent,
      "add-complete": _vm.onAddComplete,
      "edit-complete": _vm.onEditComplete,
      "close": function($event) {
        _vm.visible = false
      }
    }
  }) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1007:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-list-container"
  }, [_c('source-dialog-form', {
    attrs: {
      "value": _vm.content,
      "dialog-mode": false
    },
    on: {
      "input": function($event) {
        _vm.content = arguments[0]
      }
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Ссылка по ГОСТ:")]), _vm._v(" "), _c('base-text-copy', {
    attrs: {
      "value": _vm.formattedLink,
      "tooltip": "Копировать текст ссылки"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1008:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-list-page"
  }, [_c('ad-block'), _vm._v(" "), _c('h2', [_vm._v("Автоматический генератор ссылок по ГОСТ онлайн")]), _vm._v(" "), _c('simple-list-container'), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    ref: "content",
    staticClass: "content",
    attrs: {
      "contenteditable": _vm.enabled
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDefaultAuthorData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDefaultSourceData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var getDefaultAuthorData = function getDefaultAuthorData() {
  return {
    lastName: '',
    firstName: '',
    firstNameInitial: '',
    extraName: '',
    extraNameInitial: ''
  };
};
var getDefaultSourceData = function getDefaultSourceData() {
  return {
    type: 'article',
    authors: [],
    pages: '',
    source: '',
    title: '',
    year: '',
    url: '',
    accessMode: 'free',
    accessDate: __WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD')
  };
};

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-bar"
  }, [_c('counters-block'), _vm._v(" "), _vm._l((_vm.links), function(link) {
    return [(link.page && link.page !== _vm.$route.name) ? _c('router-link', {
      attrs: {
        "to": {
          name: link.page
        }
      }
    }, [_vm._v("\n      " + _vm._s(link.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (link.link) ? _c('a', {
      attrs: {
        "href": link.link
      }
    }, [_vm._v("\n      " + _vm._s(link.title) + "\n    ")]) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1011:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lit-list-view"
  }, [_c('h4', [_vm._v("Список литературы")]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "flip-list"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('item', {
      key: item.id,
      attrs: {
        "content": item.content,
        "label": item.label
      }
    })
  }))], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1012:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toolbar-view"
  }, _vm._l((_vm.actions), function(action) {
    return (action.visible !== false) ? _c('md-button', {
      key: action.action,
      staticClass: "action",
      class: {
        'separator-after': action.separatorAfter, 'md-primary': action.highlight
      },
      nativeOn: {
        "click": function($event) {
          _vm.onAction(action)
        }
      }
    }, [_c('md-icon', {
      staticClass: "md-size-2x"
    }, [_vm._v("\n      " + _vm._s(action.icon) + "\n      "), _c('md-tooltip', [_vm._v(_vm._s(action.title))])], 1)], 1) : _vm._e()
  }))
},staticRenderFns: []}

/***/ }),

/***/ 1013:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-page"
  }, [_c('common-bar-container', {
    on: {
      "login": _vm.auth,
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('article-container', {
    staticClass: "article-container",
    on: {
      "auth": function($event) {
        _vm.$emit('auth', arguments[0])
      }
    }
  }), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1014:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "container"
  }, [_c('canvas', {
    ref: "canvas"
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "question"
  }, [_vm._v("\n      Почему названия статей и имена авторов отображаются в верхнем регистре? Можно ли это исправить?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "answer"
  }, [_vm._v("\n      К сожалению, именно в таком виде эти данные отдает E-library.\n      Мы никак не можем это исправить, т.к. автоматическое преобразование к правильному регистру невозможно. Если вам принципиален этот момент, вы можете исправить вручную, нажав кнопку «Дополнительно».\n    ")]), _vm._v(" "), _c('h4', {
    staticClass: "question"
  }, [_vm._v("\n      Я сформировал ссылки по ГОСТ, но у меня проблемы с правильной нумерацией ссылок. Может ли ваш проект в этом помочь?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "answer"
  }, [_vm._v("\n      В будущем мы планируем реализовать текстовый редактор, который будет автоматически нумеровать ссылки в правильном порядке. Вы можете ознакомиться "), _c('router-link', {
    attrs: {
      "to": {
        name: 'editor'
      }
    }
  }, [_vm._v("с пробной тестовой версией")]), _vm._v(" нашего редактора. Кроме того, если вы используете текстовые процессоры, такие как Microsoft Word или OpenOffice Writer, вы можете добавлять элементы литературы в качестве концевых сносок.\n    ")], 1), _vm._v(" "), _c('h4', {
    staticClass: "question"
  }, [_vm._v("\n      Я попробовал воспользоваться вашим редакторам, но там нет возможности вставки изображений, формул, таблиц и даже разделения статьи на разделы. Чем он тогда может мне помочь?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "answer"
  }, [_vm._v("\n      С сожалению, на текущий момент эти функции действительно не реализованы. Вы можете использовать редактор для написания текстовой части статьи, затем экспортировать результат Word, после чего добавить требуемые элементы.\n    ")])]), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\n        ArtJump — вопросы и ответы\n      ")])])
}]}

/***/ }),

/***/ 1016:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source-dialog-expanded-header"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('md-radio', {
    attrs: {
      "md-value": "elibrary",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("Ссылка на статью на E-Library.ru")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.$v.elibraryLink && _vm.$v.elibraryLink.$error
    },
    nativeOn: {
      "click": function($event) {
        _vm.ensureType('elibrary')
      }
    }
  }, [_c('label', [_vm._v("Ссылка")]), _vm._v(" "), _c('md-input', {
    ref: "elibraryInput",
    attrs: {
      "disabled": _vm.disabled || _vm.type !== 'elibrary'
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onLoad($event)
      }
    },
    model: {
      value: (_vm.elibraryLink),
      callback: function($$v) {
        _vm.elibraryLink = $$v
      },
      expression: "elibraryLink"
    }
  }), _vm._v(" "), (_vm.$v.elibraryLink && _vm.$v.elibraryLink.$error) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("\n        Укажите ссылку на статью E-library вида https://elibrary.ru/item.asp?id=123456789\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('md-radio', {
    attrs: {
      "md-value": "resource",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("Ссылка на электронный ресурс")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.$v.resourceLink && _vm.$v.resourceLink.$error
    },
    nativeOn: {
      "click": function($event) {
        _vm.ensureType('resource')
      }
    }
  }, [_c('label', [_vm._v("Ссылка")]), _vm._v(" "), _c('md-input', {
    ref: "resourceInput",
    attrs: {
      "disabled": _vm.disabled || _vm.type !== 'resource'
    },
    model: {
      value: (_vm.resourceLink),
      callback: function($$v) {
        _vm.resourceLink = $$v
      },
      expression: "resourceLink"
    }
  }), _vm._v(" "), (_vm.$v.resourceLink && _vm.$v.resourceLink.$error) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v("\n        Укажите URL электронного ресурса\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onToggleCustom
    }
  }, [_vm._v("Дополнительно...")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onLoad
    }
  }, [_vm._v("Загрузить")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1017:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog', {
    ref: "dialog",
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('md-dialog-title', [_vm._v("\n    Добавление ссылки на источник\n  ")]), _vm._v(" "), _c('md-dialog-content', {
    staticClass: "source-dialog-content"
  }, [_c('source-dialog-form', {
    attrs: {
      "value": _vm.content
    },
    on: {
      "input": _vm.setContent
    }
  })], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), (_vm.action === 'add') ? _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.onAdd
    }
  }, [_vm._v("Добавить")]) : _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.onSave
    }
  }, [_vm._v("Сохранить")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1018:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "docs-sidebar-container"
  }, [_c('sidebar-view', {
    ref: "sidebar",
    attrs: {
      "item-key-field": "name",
      "list": _vm.itemsList,
      "common-actions": _vm.commonActions,
      "item-actions": _vm.itemActions
    },
    on: {
      "common-action": _vm.onCommonAction,
      "item-action": _vm.onItemAction
    }
  }), _vm._v(" "), _c('doc-name-dialog', {
    ref: "dialog",
    on: {
      "confirm": _vm.performDocCreate
    },
    model: {
      value: (_vm.currentDocName),
      callback: function($$v) {
        _vm.currentDocName = $$v
      },
      expression: "currentDocName"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1019:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isExpanded) ? _c('div', {
    ref: "appDrawer",
    staticClass: "sidebar-view",
    attrs: {
      "md-active": _vm.visible
    },
    on: {
      "close": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-transparent",
    attrs: {
      "md-elevation": "0"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), (_vm.commonActions && _vm.commonActions.length) ? _c('div', {
    staticClass: "common-actions"
  }, _vm._l((_vm.commonActions), function(action) {
    return _c('md-button', {
      key: action.key,
      nativeOn: {
        "click": function($event) {
          _vm.onCommonAction(action.key)
        }
      }
    }, [_vm._v("\n      " + _vm._s(action.name) + "\n    ")])
  })) : _vm._e(), _vm._v(" "), _c('md-list', _vm._l((_vm.list), function(item) {
    return _c('md-list-item', {
      key: item[_vm.itemKeyField]
    }, [_c('div', {
      staticClass: "md-list-text-container"
    }, [_c('span', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _vm._l((_vm.itemActions), function(action) {
      return _c('md-button', {
        key: action.key,
        staticClass: "md-icon-button md-list-action",
        nativeOn: {
          "click": function($event) {
            _vm.onItemAction(action.key, item)
          }
        }
      }, [_c('md-icon', [_vm._v("\n          " + _vm._s(action.icon) + "\n        ")]), _vm._v(" "), (action.name) ? _c('md-tooltip', [_vm._v("\n          " + _vm._s(action.name) + "\n        ")]) : _vm._e()], 1)
    })], 2)
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1020:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),

/***/ 1021:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-panel-view"
  }, [_c('div', {
    staticClass: "doc-area"
  }, [_c('md-icon', {
    nativeOn: {
      "click": function($event) {
        _vm.$emit('open-menu')
      }
    }
  }, [_vm._v("\n      menu\n      "), _c('md-tooltip', [_vm._v("Меню")])], 1), _vm._v(" "), _c('span', {
    staticClass: "name-content",
    on: {
      "click": function($event) {
        _vm.$emit('rename')
      }
    }
  }, [(_vm.docName !== null) ? [_vm._v("\n        " + _vm._s(_vm.docName) + "\n      ")] : [_vm._v("\n        Несохраненный документ\n      ")]], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "auth-area"
  }, [(_vm.isAuthorized) ? _c('div', {
    staticClass: "login"
  }, [_c('span', {
    staticClass: "login-content"
  }, [_vm._v(_vm._s(_vm.profileName))]), _vm._v(" "), _c('a', {
    staticClass: "link logout",
    on: {
      "click": function($event) {
        _vm.$emit('logout')
      }
    }
  }, [_vm._v("Выйти")])]) : _c('a', {
    staticClass: "link login",
    on: {
      "click": function($event) {
        _vm.$emit('login')
      }
    }
  }, [_vm._v("Войти")])])])
},staticRenderFns: []}

/***/ }),

/***/ 1022:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    on: {
      "auth": _vm.auth,
      "logout": _vm.logout
    }
  }), _vm._v(" "), _c('md-snackbar', {
    ref: "messageBar",
    attrs: {
      "md-position": "bottom center"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1023:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-dialog-prompt', {
    ref: "dialog",
    attrs: {
      "value": _vm.value !== null ? _vm.value : '',
      "md-title": "Введите имя документа",
      "md-input-maxlength": "30",
      "md-confirm-text": _vm.confirmText
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', arguments[0])
      },
      "close": _vm.close
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1024:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('lit-list-view', {
    attrs: {
      "items": _vm.orderedSources
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1025:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    ref: "element",
    staticClass: "lit-item"
  }, [(_vm.showLabel) ? [(_vm.label) ? [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")] : [_vm._v("\n      ?\n    ")]] : _vm._e(), _vm._v("\n  " + _vm._s(_vm.formattedLink) + "\n  ")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1026:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source-dialog-form"
  }, [(_vm.loading) ? _c('md-progress', {
    attrs: {
      "md-indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dialogMode) ? _c('source-dialog-header', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.loading
    },
    on: {
      "load-article": _vm.getElibraryArticle,
      "load-digital-resource": _vm.getDigitalResource,
      "input": function($event) {
        _vm.$emit('input', arguments[0])
      }
    }
  }) : _c('source-dialog-expanded-header', {
    attrs: {
      "value": _vm.value,
      "disabled": _vm.loading
    },
    on: {
      "load-article": _vm.getElibraryArticle,
      "load-digital-resource": _vm.getDigitalResource,
      "toggle-custom": _vm.onToggleCustom
    }
  }), _vm._v(" "), _c('source-dialog-custom', {
    class: {
      'custom-toggable': !_vm.dialogMode, 'hidden': !_vm.showCustom
    },
    attrs: {
      "value": _vm.value,
      "disabled": _vm.loading
    },
    on: {
      "input": function($event) {
        _vm.$emit('input', arguments[0])
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1027:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "base-text-copy"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "input",
    staticClass: "input",
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onCopy($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "copy-button md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onCopy($event)
      }
    }
  }, [_c('md-icon', [_vm._v("content_copy")]), _vm._v(" "), (_vm.tooltip) ? _c('md-tooltip', [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1052:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1054:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(681)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(571),
  /* template */
  __webpack_require__(1010),
  /* scopeId */
  "data-v-5e5e0ea6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 166:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOrderedLinks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cheerio__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cheerio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cheerio__);


function getOrderedLinks(content) {
  var $ = __WEBPACK_IMPORTED_MODULE_0_cheerio___default.a.load(content);
  var orderedLinks = [];
  $('.link').each(function (index, element) {
    orderedLinks.push($(element).data('link'));
  });
  return orderedLinks;
}

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vocabularies_accessModes_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);



/* harmony default export */ __webpack_exports__["a"] = (function (content) {
  var firstPart = '';
  var secondPart = '';
  var thridPart = '';

  if (content.authors && content.authors.length > 0 && content.authors.length < 5) {
    firstPart = formatAuthor(content.authors[0], true);
  }
  if (firstPart && content.title) {
    firstPart += ' ' + content.title;
  } else {
    firstPart = content.title;
  }

  if (content.authors && content.authors.length > 0) {
    secondPart = content.authors.slice(0, 4).map(function (a) {
      return formatAuthor(a, false);
    }).join(', ');
    if (content.authors.length >= 5) {
      secondPart += ' и др.';
    }
  }

  var subParts = [];
  if (content.source) {
    var value = content.source;
    if (content.type === 'resource') {
      value += '[сайт]';
    }
    subParts.push(value);
  }
  if (content.year) {
    subParts.push(content.year + ' \u0433.');
  }
  if (content.issue) {
    subParts.push('\u2116 ' + content.issue);
  }
  if (content.pages) {
    subParts.push('\u0421. ' + content.pages);
  }
  if (content.type === 'resource' && content.url) {
    var values = ['\u0440\u0435\u0436\u0438\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u0430: ' + content.url];

    if (content.accessMode) {
      var _value = __WEBPACK_IMPORTED_MODULE_0__vocabularies_accessModes_js__["a" /* default */].find(function (am) {
        return am.key === content.accessMode;
      });
      if (_value) {
        values.push(_value.title);
      }
    }

    if (content.accessDate) {
      var dateValue = __WEBPACK_IMPORTED_MODULE_1_moment___default()(content.accessDate, 'YYYY-MM-DD');
      if (dateValue) {
        values.push('(дата обращения: ' + dateValue.format('DD.MM.YYYY') + ')');
      }
    }

    values.push('— Загл. с экрана.');

    subParts.push(values.join(' '));
  }
  if (subParts.length > 0) {
    thridPart = subParts.join(' — ');
  }

  var result = '';
  if (firstPart && secondPart) {
    result = firstPart + ' / ' + secondPart;
  } else if (firstPart && !secondPart) {
    result = firstPart;
  } else if (!firstPart && secondPart) {
    result = secondPart;
  }
  if (thridPart) {
    result += ' // ' + thridPart;
  }
  return result;
});

function formatAuthor(content) {
  var lastNameFirst = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var initials = content.firstNameInitial + '.';
  if (content.extraNameInitial) {
    initials += ' ' + content.extraNameInitial + '.';
  }
  return lastNameFirst ? content.lastName + ', ' + initials : initials + ' ' + content.lastName;
}

/***/ }),

/***/ 235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return elibraryRegExp; });
var elibraryRegExp = /(http|https\:\/\/)?(?:www\.)?elibrary\.ru\/item\.asp\?id=(\d+)/gi;

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  key: 'free',
  title: 'свободный'
}, {
  key: 'authorize',
  title: 'требуется авторизация'
}]);

/***/ }),

/***/ 237:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CONTENT_HTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ADD_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EDIT_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SOURCE_ORDER_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ADD_LINK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_AUTH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_DOCS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_DOC_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return RENAME_DOC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_DOC_SAVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CREATE_DOC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_CURRENT_DOC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_CURRENT_DOC; });
var SET_CONTENT_HTML = 'SET_CONTENT_HTML';

var ADD_SOURCE = 'ADD_SOURCE';
var EDIT_SOURCE = 'EDIT_SOURCE';
var SET_SOURCE_ORDER_INDEX = 'SET_SOURCE_ORDER_INDEX';

var ADD_LINK = 'ADD_LINK';

var SET_AUTH_DATA = 'SET_AUTH_DATA';
var SET_DOCS = 'SET_DOCS';
var SET_DOC_DATA = 'SET_DOC_DATA';
var RENAME_DOC = 'RENAME_DOC';
var SET_DOC_SAVED = 'SET_DOC_SAVED';
var CREATE_DOC = 'CREATE_DOC';
var SET_CURRENT_DOC = 'SET_CURRENT_DOC';
var UPDATE_CURRENT_DOC = 'UPDATE_CURRENT_DOC';

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports = {"universal":50,"tag":30,"attribute":1,"pseudo":0,"descendant":-1,"child":-1,"parent":-1,"sibling":-1,"adjacent":-1}

/***/ }),

/***/ 257:
/***/ (function(module, exports) {

module.exports = {"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\"","QUOT":"\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}

/***/ }),

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(568),
  /* template */
  __webpack_require__(1023),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(569),
  /* template */
  __webpack_require__(1018),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(690)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(574),
  /* template */
  __webpack_require__(1025),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(691)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(581),
  /* template */
  __webpack_require__(1026),
  /* scopeId */
  "data-v-dd8c112e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 480:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Article_vue__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Article_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Article_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_SimpleListPage_vue__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_SimpleListPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_SimpleListPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_AboutPage_vue__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_AboutPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_AboutPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_FaqPage_vue__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_FaqPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_FaqPage_vue__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/editor',
    name: 'editor',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_Article_vue___default.a
  }, {
    path: '/',
    name: 'simple',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_SimpleListPage_vue___default.a
  }, {
    path: '/about',
    name: 'about',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_AboutPage_vue___default.a
  }, {
    path: '/faq',
    name: 'faq',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_FaqPage_vue___default.a
  }]
}));

/***/ }),

/***/ 481:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_js__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters_js__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_js__ = __webpack_require__(554);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state_js__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters_js__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations_js__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_5__actions_js__["a" /* default */],
  strict: "production" !== 'production'
}));

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(689)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1022),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sortablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vuex_store__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('sortable', {
  inserted: function inserted(el, binding) {
    new __WEBPACK_IMPORTED_MODULE_3_sortablejs___default.a(el, binding.value || {});
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_material___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuelidate___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    showCommonMessage: function showCommonMessage(message) {
      this.$root.$children[0].showMessage(message);
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    handleError: function handleError(err) {
      if (err.status === 401) {
        this.$root.$children[0].logout();
      } else {
        this.showCommonMessage(err.message);
        console.log(err);
      }
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__vuex_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_domUtils_js__ = __webpack_require__(550);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isExpanded: false,
      expandableExcludeClasses: []
    };
  },


  watch: {
    isExpanded: function isExpanded(state) {
      this.$emit('update-expand-state', state);
      this.setCloseHandler(state);
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.setCloseHandler(_this.isExpanded);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.setCloseHandler(false);
  },


  methods: {
    toggleExpandState: function toggleExpandState(state) {
      this.isExpanded = state !== undefined ? !!state : !this.isExpanded;
    },
    setCloseHandler: function setCloseHandler(state) {
      var _this2 = this;

      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keyup', this.onKeyUp);
      if (state) {
        setTimeout(function () {
          document.addEventListener('click', _this2.onDocumentClick);
          document.addEventListener('keyup', _this2.onKeyUp);
        }, 0);
      }
    },
    onKeyUp: function onKeyUp(e) {
      if (e.keyCode === 27) {
        this.toggleExpandState(false);
      }
    },
    onDocumentClick: function onDocumentClick(e) {
      var _this3 = this;

      var targetParents = __WEBPACK_IMPORTED_MODULE_0__shared_domUtils_js__["a" /* getParents */](e.target, true);
      if (targetParents.some(function (el) {
        return el.classList && _this3.expandableExcludeClasses.some(function (c) {
          return el.classList.contains(c);
        });
      })) {
        return;
      }
      if (this.getExpandRoots().every(function (r) {
        return targetParents.indexOf(r) === -1;
      }) && !this.onAutoCollapse()) {
        this.toggleExpandState(false);
      }
    },
    getExpandRoots: function getExpandRoots() {
      return [this.$el];
    },
    onAutoCollapse: function onAutoCollapse() {}
  }

});

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParents;

function getParents(element) {
  var includeSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var parents = [];
  var parent = includeSelf ? element : element.parentNode;
  while (parent != null) {
    parents.push(parent);
    parent = parent.parentNode;
  }
  return parents;
}

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getOrderedLinks__ = __webpack_require__(233);


/* harmony default export */ __webpack_exports__["a"] = (function (content, links, sourcesIds) {
  var result = {};
  sourcesIds.forEach(function (sourceId) {
    result[sourceId] = null;
  });
  var orderedLinks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getOrderedLinks__["a" /* default */])(content);
  var index = 0;
  orderedLinks.forEach(function (linkId) {
    if (links[linkId].sources) {
      links[linkId].sources.forEach(function (sourceId) {
        if (result[sourceId]) {
          return;
        }
        result[sourceId] = ++index;
      });
    }
  });
  return result;
});

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_superagent__);



/* harmony default export */ __webpack_exports__["a"] = (function (url) {
  return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_1_superagent___default.a.get('/api/pageinfo.php').query({ url: url }).send().end(function (err, result) {
      if (err) {
        reject(err);
      } else {
        if (result.body && result.body.success) {
          resolve(result.body);
        } else {
          reject(new Error(result.body.message));
        }
      }
    });
  });
});

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadUserMetadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = updateUserMetadata;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_superagent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);



var auth0domain = 'art-jump';

function loadUserMetadata(userid, authkey) {
  var url = 'https://' + auth0domain + '.auth0.com/api/v2/users/' + userid;
  return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.patch(url).set('Accept', 'application/json').set('Authorization', 'bearer ' + authkey).end(function (err, response) {
      if (err) {
        reject(err);
      } else {
        resolve(response.result);
      }
    });
  });
}

function updateUserMetadata(userid, dump, authkey) {
  return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function (resolve, reject) {
    var url = 'https://' + auth0domain + '.auth0.com/api/v2/users/' + userid;
    __WEBPACK_IMPORTED_MODULE_0_superagent___default.a.patch(url).set('Accept', 'application/json').set('Authorization', 'bearer ' + authkey).send({ user_metadata: dump }).end(function (err) {
      if (err) {
        reject(err);
      } else {
        resolve();
      }
    });
  });
}

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_getOrderedSources_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bluebird__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_identifier__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_identifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_identifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_userMetadata_js__ = __webpack_require__(553);











/* harmony default export */ __webpack_exports__["a"] = ({
  setContentHtml: function setContentHtml(_ref, content) {
    var commit = _ref.commit,
        state = _ref.state;

    var sourcesIndexes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_getOrderedSources_js__["a" /* default */])(content, state.links, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(state.sources));
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["a" /* SET_CONTENT_HTML */], { contentHtml: content });
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(sourcesIndexes).forEach(function (sourceId) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["b" /* SET_SOURCE_ORDER_INDEX */], { id: sourceId, index: sourcesIndexes[sourceId] });
    });
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["c" /* SET_DOC_SAVED */], false);
  },
  addSource: function addSource(_ref2, _ref3) {
    var commit = _ref2.commit;
    var content = _ref3.content;

    var id = __WEBPACK_IMPORTED_MODULE_5_identifier___default()(10);
    return new __WEBPACK_IMPORTED_MODULE_4_bluebird___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["d" /* ADD_SOURCE */], { id: id, content: content });
      resolve(id);
    });
  },
  editSource: function editSource(_ref4, _ref5) {
    var commit = _ref4.commit;
    var content = _ref5.content,
        sourceId = _ref5.sourceId;

    return new __WEBPACK_IMPORTED_MODULE_4_bluebird___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["e" /* EDIT_SOURCE */], { content: content, sourceId: sourceId });
      resolve();
    });
  },
  addLink: function addLink(_ref6, _ref7) {
    var commit = _ref6.commit;
    var sourceId = _ref7.sourceId;

    var id = __WEBPACK_IMPORTED_MODULE_5_identifier___default()(10);
    var content = { sources: [sourceId] };
    return new __WEBPACK_IMPORTED_MODULE_4_bluebird___default.a(function (resolve) {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["f" /* ADD_LINK */], { id: id, content: content });
      resolve(id);
    });
  },
  authenticated: function authenticated(_ref8, _ref9) {
    var commit = _ref8.commit;
    var authData = _ref9.authData,
        profile = _ref9.profile;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["g" /* SET_AUTH_DATA */], {
      isAuthorized: true,
      authToken: authData.idToken,
      profileName: profile.email,
      userId: profile.user_id
    });
    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["h" /* SET_DOCS */], profile.user_metadata.docs);
  },
  unauthenticated: function unauthenticated(_ref10) {
    var commit = _ref10.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["g" /* SET_AUTH_DATA */], {
      isAuthorized: false,
      authToken: null,
      profileName: null,
      userId: null
    });
  },
  saveDoc: function saveDoc(_ref11) {
    var commit = _ref11.commit,
        state = _ref11.state;

    var docName = state.docName;

    if (docName === null) {
      var checkDocName = function checkDocName(name, suffix) {
        if (suffix > 1) {
          name = name + '-' + suffix;
        }
        var found = state.docs.filter(function (d) {
          return d.name.toLowerCase() === name.toLowerCase();
        });
        return !!found.length;
      };
      var defaultBase = 'Статья ' + __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('DD.MM.YYYY');

      var num = 1;
      while (checkDocName(defaultBase, num)) {
        num++;
      }
      if (num > 1) {
        docName = defaultBase + '-' + num;
      } else {
        docName = defaultBase;
      }
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["i" /* SET_CURRENT_DOC */], docName);
    }

    var currentDoc = {
      name: docName,
      content: state.contentHtml,
      sources: state.sources,
      links: state.links
    };
    var oldDocs = state.docs.filter(function (d) {
      return d.name !== docName;
    });
    var dump = {
      docs: [currentDoc].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(oldDocs))
    };
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__shared_userMetadata_js__["a" /* updateUserMetadata */])(state.userId, dump, state.authToken).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["c" /* SET_DOC_SAVED */], true);
      commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["j" /* UPDATE_CURRENT_DOC */]);
    });
  },
  loadDoc: function loadDoc(_ref12) {
    var commit = _ref12.commit,
        state = _ref12.state;
    var docName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';

    return new __WEBPACK_IMPORTED_MODULE_4_bluebird___default.a(function (resolve, reject) {
      var doc = state.docs.find(function (d) {
        return d.name === docName;
      });
      if (doc) {
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["k" /* SET_DOC_DATA */], doc);
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["c" /* SET_DOC_SAVED */], true);
        commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["i" /* SET_CURRENT_DOC */], docName);
        resolve();
      } else {
        reject(new Exception('Document not found'));
      }
    });
  },
  renameDoc: function renameDoc(_ref13, _ref14) {
    var commit = _ref13.commit,
        state = _ref13.state;
    var oldDocName = _ref14.oldDocName,
        newDocName = _ref14.newDocName;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["l" /* RENAME_DOC */], { oldDocName: oldDocName, newDocName: newDocName });
  },
  createDoc: function createDoc(_ref15, docName) {
    var commit = _ref15.commit;

    commit(__WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["m" /* CREATE_DOC */], docName);
  }
});

/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  linksLabels: function linksLabels(state) {
    var result = {};
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.links).forEach(function (linkId) {
      var numbers = [];
      state.links[linkId].sources.forEach(function (sourceId) {
        numbers.push(state.sources[sourceId].orderIndex);
      });
      result[linkId] = '[' + numbers.join(', ') + ']';
    });
    return result;
  },
  orderedSources: function orderedSources(state) {
    var result = [];
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.sources).forEach(function (sourceId) {
      var content = state.sources[sourceId];
      result.push({
        id: sourceId,
        index: content.orderIndex,
        label: '[' + content.orderIndex + ']',
        content: content
      });
    });
    return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.sortBy(result, function (s) {
      return s.index;
    });
  }
});

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);



var _SET_CONTENT_HTML$ADD;




/* harmony default export */ __webpack_exports__["a"] = (_SET_CONTENT_HTML$ADD = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["a" /* SET_CONTENT_HTML */], function (state, _ref) {
  var contentHtml = _ref.contentHtml;

  state.contentHtml = contentHtml;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["d" /* ADD_SOURCE */], function (state, _ref2) {
  var id = _ref2.id,
      content = _ref2.content;

  state.sources = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sources, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, content));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["e" /* EDIT_SOURCE */], function (state, _ref3) {
  var content = _ref3.content,
      sourceId = _ref3.sourceId;

  state.sources = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sources, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, sourceId, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(content)));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["b" /* SET_SOURCE_ORDER_INDEX */], function (state, _ref4) {
  var id = _ref4.id,
      index = _ref4.index;

  state.sources = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sources, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.sources[id], { orderIndex: index })));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["f" /* ADD_LINK */], function (state, _ref5) {
  var id = _ref5.id,
      content = _ref5.content;

  state.links = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.links, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, id, content));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["g" /* SET_AUTH_DATA */], function (state, _ref6) {
  var isAuthorized = _ref6.isAuthorized,
      authToken = _ref6.authToken,
      profileName = _ref6.profileName,
      userId = _ref6.userId;

  state.isAuthorized = isAuthorized;
  state.authToken = authToken;
  state.profileName = profileName;
  state.userId = userId;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["h" /* SET_DOCS */], function (state, docs) {
  state.docs = docs;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["k" /* SET_DOC_DATA */], function (state, _ref7) {
  var content = _ref7.content,
      sources = _ref7.sources,
      links = _ref7.links;

  state.contentHtml = content;
  state.sources = sources;
  state.links = links;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["c" /* SET_DOC_SAVED */], function (state, value) {
  state.docSaved = value;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["l" /* RENAME_DOC */], function (state, _ref8) {
  var oldDocName = _ref8.oldDocName,
      newDocName = _ref8.newDocName;

  var isCrrentDoc = oldDocName === state.docName;
  state.docs = state.docs.map(function (doc) {
    if (doc.name === oldDocName) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc, { name: newDocName });
    } else {
      return doc;
    }
  });
  if (isCrrentDoc) {
    state.docName = newDocName;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["m" /* CREATE_DOC */], function (state, name) {
  state.docs.push({
    name: name,
    content: '',
    sources: {},
    links: {}
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["i" /* SET_CURRENT_DOC */], function (state, docName) {
  state.docName = docName;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_SET_CONTENT_HTML$ADD, __WEBPACK_IMPORTED_MODULE_2__mutation_types_js__["j" /* UPDATE_CURRENT_DOC */], function (state) {
  state.docs = state.docs.map(function (doc) {
    if (doc.name === state.docName) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, doc, {
        content: state.contentHtml,
        sources: state.sources,
        links: state.links
      });
    } else {
      return doc;
    }
  });
}), _SET_CONTENT_HTML$ADD);

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  links: {},
  sources: {},
  contentHtml: "\n    <h2>\u0412\u0432\u0435\u0434\u0435\u043D\u0438\u0435</h2>\n    <div class=\"content-stub\" contenteditable=\"false\">\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435</div>\n    <h2>\u041C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u0438 \u043C\u0435\u0442\u043E\u0434\u044B</h2>\n    <div class=\"content-stub\" contenteditable=\"false\">\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435</div>\n    <h2>\u0420\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B</h2>\n    <div class=\"content-stub\" contenteditable=\"false\">\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435</div>\n    <h2>\u0417\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435</h2>\n    <div class=\"content-stub\" contenteditable=\"false\">\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u043C\u043E\u0435</div>\n  ",
  docs: [],
  docName: null,
  docSaved: false,

  profileName: null,
  isAuthorized: false,
  authToken: null,
  userId: null
});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_auth0_lock__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_auth0_lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_auth0_lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bluebird__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bluebird__);









/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  name: 'app',
  data: function data() {
    return {
      message: null,
      authLock: null
    };
  },
  created: function created() {
    var authData;
    if (localStorage && (authData = localStorage.getItem('auth'))) {
      authData = JSON.parse(authData);
      this.onAuthenticated(authData);
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapActions */])(['authenticated', 'unauthenticated']), {
    getAuthLock: function getAuthLock() {
      if (!this.authLock) {
        this.authLock = new __WEBPACK_IMPORTED_MODULE_4_auth0_lock___default.a('3jPwkv2_50tKdzYS1xVXjS1lWlg8yo2h', 'art-jump.auth0.com', {
          language: 'ru',
          theme: {
            labeledSubmitButton: false
          },
          languageDictionary: {
            title: 'Авторизация'
          },
          auth: {
            redirect: false,
            params: {
              scope: 'openid app_metadata email'
            }
          }
        });
      }
      return this.authLock;
    },
    auth: function auth(callback) {
      var _this = this;

      this.getAuthLock().on('authenticated', function (result) {
        _this.onAuthenticated(result).then(function () {
          if (localStorage) {
            localStorage.setItem('auth', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result));
          }
          if (callback) {
            _this.$nextTick(function () {
              callback();
            });
          }
        }).catch(function (err) {
          _this.handleError(err);
        });
      });
      this.getAuthLock().show();
    },
    onAuthenticated: function onAuthenticated(authData) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_5_bluebird___default.a(function (resolve, reject) {
        _this2.getAuthLock().getUserInfo(authData.accessToken, function (error, profile) {
          if (error) {
            reject(error);
            return;
          }
          _this2.authenticated({ authData: authData, profile: profile });
          resolve();
        });
      });
    },
    logout: function logout() {
      this.unauthenticated();
      if (localStorage) {
        localStorage.removeItem('auth');
      }
    },
    showMessage: function showMessage(message) {
      var _this3 = this;

      this.message = message;
      this.$nextTick(function () {
        _this3.$refs.messageBar.open();
      });
    }
  })
});

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AdBlock',

  components: {},

  props: {},

  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var s1 = document.createElement('script');
    s1.setAttribute('type', 'text/javascript');
    s1.setAttribute('src', '//j.contema.ru/Contema.js');
    s1.addEventListener('load', this.onScriptLoaded);
    this.$el.appendChild(s1);
  },


  computed: {},

  methods: {
    onScriptLoaded: function onScriptLoaded() {
      window.Contema.load(20069, { adv_format: "banner", adv_size: 1 });
    }
  }
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_elib_parser__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_elib_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_elib_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LitListContainer_vue__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LitListContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LitListContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArticleView_vue__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArticleView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ArticleView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SourceDialogContainer_vue__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SourceDialogContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SourceDialogContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExportContainer_vue__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExportContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ExportContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToolbarView_vue__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToolbarView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ToolbarView_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DocsSidebarContainer_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DocsSidebarContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__DocsSidebarContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BaseTimer_vue__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_BaseTimer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_BaseTimer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuedraggable__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_identifier__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_identifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_identifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_getOrderedLinks__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(41);





















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ArticleContainer',
  components: {
    BaseTimer: __WEBPACK_IMPORTED_MODULE_9__components_BaseTimer_vue___default.a,
    LitListContainer: __WEBPACK_IMPORTED_MODULE_3__LitListContainer_vue___default.a,
    ArticleView: __WEBPACK_IMPORTED_MODULE_4__ArticleView_vue___default.a,
    SourceDialogContainer: __WEBPACK_IMPORTED_MODULE_5__SourceDialogContainer_vue___default.a,
    DocsSidebarContainer: __WEBPACK_IMPORTED_MODULE_8__DocsSidebarContainer_vue___default.a,
    ExportContainer: __WEBPACK_IMPORTED_MODULE_6__ExportContainer_vue___default.a,
    ToolbarView: __WEBPACK_IMPORTED_MODULE_7__ToolbarView_vue___default.a,
    draggable: __WEBPACK_IMPORTED_MODULE_11_vuedraggable___default.a
  },
  data: function data() {
    return {
      id: '28834698',
      title: '',
      items: [],
      links: {},
      sources: {},
      contentUpdating: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapState */])({
    contentHtml: function contentHtml(state) {
      return state.contentHtml;
    },
    isAuthorized: function isAuthorized(state) {
      return state.isAuthorized;
    },
    docSaved: function docSaved(state) {
      return state.docSaved;
    },
    docName: function docName(state) {
      return state.docName;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["d" /* mapGetters */])(['linksLabels']), {
    formattedLinks: function formattedLinks() {
      var _this = this;

      var result = {};
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.links).forEach(function (linkId) {
        var labels = [];
        _this.links[linkId].sources.forEach(function (sourceId) {
          labels.push(_this.sources[sourceId].number);
        });
        result[linkId] = '[' + lablinksLabelsels.join(', ') + ']';
      });
      return result;
    }
  }),
  watch: {
    contentHtml: function contentHtml(content) {
      if (this.contentUpdating) {
        this.contentUpdating = false;
      } else {
        this.$refs.editor.forceUpdateContent(content);
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('beforeunload', this.onUnload);
  },
  beforeDestory: function beforeDestory() {
    window.removeEventListener('beforeunload', this.onUnload);
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["a" /* mapActions */])(['setContentHtml', 'addSource', 'addLink', 'saveDoc', 'loadDoc', 'renameDoc']), {
    onSave: function onSave() {
      var _this2 = this;

      if (!this.isAuthorized) {
        this.login(this.saveDoc);
      } else {
        this.saveDoc().then().catch(function (err) {
          _this2.handleError(err);
        });
        this.showCommonMessage('Документ сохранен');
      }
    },
    onSaveTimer: function onSaveTimer() {
      var _this3 = this;

      if (this.isAuthorized && !this.docSaved) {
        this.saveDoc().then().catch(function (err) {
          _this3.handleError(err);
        });
      }
    },
    onSetDocName: function onSetDocName(newDocName) {
      this.renameDoc({ oldDocName: this.docName, newDocName: newDocName });
    },
    onUnload: function onUnload(e) {
      if (!this.docSaved) {
        var confirmationMessage = 'Документ не сохранен. Вы точно хотите закрыть окно?';
        e.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    },
    onLoad: function onLoad() {
      if (!this.isAuthorized) {
        this.login(this.loadDoc);
      } else {
        this.loadDoc();
      }
    },
    onEditorAction: function onEditorAction(action) {
      if (this.$refs.editor) {
        this.$refs.editor[action]();
      }
    },
    onExport: function onExport(format) {
      this.$refs.exportContainer.export(format);
    },
    onItemRemove: function onItemRemove(item) {
      this.items = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.without(this.items, item);
    },
    onChangeContent: function onChangeContent(content) {
      if (content !== this.contentHtml) {
        this.contentUpdating = true;
        this.setContentHtml(content);
      }
    },
    openAddSourceDialog: function openAddSourceDialog() {
      this.$refs.sourceDialog.reset();
      this.$refs.sourceDialog.add();
    },
    onAddLink: function onAddLink(linkId) {
      this.$refs.editor.addLink(linkId);
    },
    onEditLink: function onEditLink(linkId) {
      this.$refs.sourceDialog.edit(linkId);
    },
    login: function login(callback) {
      this.$emit('auth', callback);
    }
  })
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LinkGenerator: __webpack_require__(982),
    BaseEditor: __webpack_require__(975)
  },
  data: function data() {
    return {
      editor: null,
      editingSubElement: null,
      editingType: null
    };
  },

  props: {
    contentHtml: String,
    docName: String,
    udc: String,
    links: {
      type: Object
    }
  },
  computed: {
    contentFullHtml: function contentFullHtml() {
      var content = '';
      content += '<div class="udc">УДК ' + _.escape(this.udc) + '</div>';
      if (this.docName) {
        content += '<h1 class="doc-name">' + _.escape(this.docName) + '</h1>';
      } else {
        content += '<h1 class="doc-name stub">Название статьи</h1>';
      }
      content += '<div class="content" contenteditable="true">' + this.contentHtml + '</div>';
      return content;
    }
  },
  watch: {
    links: function links(_links) {
      var _this = this;

      this.$nextTick(function () {
        _this.updateLinks(_links);
      });
    }
  },
  methods: {
    onKeyDown: function onKeyDown(event) {
      if (event.which === 13 && this.editingType === 'doc-name') {
        this.onEditingDocNameEnd();
        this.$refs.editor.removeFocus();
      }
    },
    onContentClick: function onContentClick(event) {
      if (event.target.classList.contains('doc-name')) {
        this.onEditingDocNameStart(event.target);
      }
      if (event.target.classList.contains('content-stub')) {
        this.onEditingContentStart(event.target);
      }
    },
    onEditingContentStart: function onEditingContentStart(element) {
      var newElement = document.createElement('div');
      var innerElement = document.createElement('br');

      element.parentElement.insertBefore(newElement, element);
      element.parentElement.insertBefore(innerElement, element);
      element.remove();

      var editor = this.$refs.editor;
      var selection = editor.getContentWindow().getSelection();
      var range = editor.getContentDocument().createRange();
      range.selectNodeContents(newElement);
      selection.removeAllRanges();
      selection.addRange(range);
    },
    onEditingDocNameStart: function onEditingDocNameStart(element) {
      this.editingSubElement = element;
      this.editingType = 'doc-name';

      if (element.classList.contains('stub')) {
        element.classList.remove('stub');
        element.innerText = '';
      }
      element.setAttribute('contenteditable', 'true');
      element.addEventListener('blur', this.onEditingDocNameEnd);
      setTimeout(function () {
        element.focus();
      }, 0);
    },
    onEditingDocNameEnd: function onEditingDocNameEnd() {
      this.$emit('set-doc-name', this.editingSubElement.innerText);
      this.editingSubElement.removeAttribute('contenteditable');
      this.editingSubElement.removeEventListener('blur', this.onEditingDocNameEnd);

      this.editingSubElement = null;
      this.editingType = null;
    },
    editorUndo: function editorUndo() {
      this.editor.execCommand('undo');
    },
    editorRedo: function editorRedo() {
      this.editor.execCommand('redo');
    },
    editorCopy: function editorCopy() {
      this.editor.execCommand('Copy');
    },
    editorCut: function editorCut() {
      this.editor.execCommand('Cut');
    },
    editorPaste: function editorPaste() {
      this.editor.execCommand('Paste');
    },
    editorHeader: function editorHeader() {
      this.editor.focus();
      this.editor.selection.setContent('<h2>' + this.editor.selection.getContent() + '</h2>');
    },
    editorList: function editorList() {
      this.editor.execCommand('InsertUnorderedList');
    },
    updateLinks: function updateLinks(links) {},
    addLink: function addLink(linkId) {
      var image = this.$refs.generator.generate('[1]');

      this.$refs.editor.insertContent('<img class="link" src="' + image + '" data-link="' + linkId + '" data-label="[1]"/>');
    },
    onUpdateContent: function onUpdateContent(content) {
      this.$emit('input', content);
    },
    openAddSourceDialog: function openAddSourceDialog() {
      this.$emit('add-source');
    },
    export: function _export(format) {
      this.$emit('export', format);
    },
    forceUpdateContent: function forceUpdateContent(content) {
      this.editor.setContent(content);
    },
    onChange: function onChange() {
      if (this.editor) {
        this.$emit('input', this.editor.getContent());
      }
    },
    onInput: function onInput(value) {
      this.$emit('input', value);
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BaseEditor',

  components: {},

  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    value: String
  },

  data: function data() {
    return {
      observer: null,
      htmlHeader: '<html><head><link rel="stylesheet" href="/static/editor.css"></head><body>',
      htmlFooter: '</body></html>'
    };
  },


  computed: {},

  methods: {
    onClick: function onClick(event) {
      this.$emit('click', event);
    },
    onKeyDown: function onKeyDown(event) {
      this.$emit('keydown', event);
    },
    onKeyUp: function onKeyUp(event) {
      this.$emit('keyup', event);
    },
    execCommand: function execCommand() {
      var _getContentDocument;

      (_getContentDocument = this.getContentDocument()).execCommand.apply(_getContentDocument, arguments);
    },
    insertContent: function insertContent(html) {
      this.getContentDocument().execCommand('insertHTML', false, html);
    },
    getContentDocument: function getContentDocument() {
      return this.$refs.content.contentDocument;
    },
    getContentWindow: function getContentWindow() {
      return this.$refs.content.contentWindow;
    },
    removeFocus: function removeFocus() {
      this.getContentDocument().getSelection().removeAllRanges();
    }
  },

  mounted: function mounted() {
    var _this = this;

    var frameDoc = this.getContentDocument();
    frameDoc.open();
    frameDoc.writeln('' + this.htmlHeader + this.value + this.htmlFooter);
    frameDoc.close();

    this.observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        _this.$emit('input', frameDoc.body.innerHTML);
      });
    });
    var config = { attributes: true, childList: true, characterData: true, subtree: true };
    this.observer.observe(frameDoc, config);

    this.getContentDocument().addEventListener('click', this.onClick);
    this.getContentDocument().addEventListener('keydown', this.onKeyDown);
    this.getContentDocument().addEventListener('keyup', this.onKeyUp);
  },
  beforeDestroy: function beforeDestroy() {
    this.observer.disconnect();
    this.getContentDocument().removeEventListener('click', this.onClick);
    this.getContentDocument().removeEventListener('keydown', this.onKeyDown);
    this.getContentDocument().removeEventListener('keyup', this.onKeyUp);
  }
});

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'BaseTextCopy',
  props: {
    value: {
      type: String,
      default: ''
    },
    tooltip: String
  },
  methods: {
    onCopy: function onCopy() {
      if (this.$refs.input) {
        this.$refs.input.select();
        document.execCommand('copy');
      }
    }
  }
});

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    timeout: {
      type: Number
    },
    enabled: {
      type: Boolean,
      default: true
    },

    suppress: {
      type: Boolean,
      default: false
    },
    immediate: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      intervalId: null
    };
  },
  mounted: function mounted() {
    if (this.enabled) {
      this.on();
    }
  },
  activated: function activated() {
    if (this.enabled) {
      this.on();
    }
  },
  deactivated: function deactivated() {
    this.off();
  },
  destroyed: function destroyed() {
    this.off();
  },

  watch: {
    enabled: function enabled(value) {
      if (value) {
        this.on();
      } else {
        this.off();
      }
    }
  },
  methods: {
    on: function on() {
      if (!this.intervalId) {
        this.intervalId = setInterval(this.timer, this.timeout);
        if (this.immediate) {
          this.timer();
        }
      }
    },
    off: function off() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    timer: function timer() {
      if (!this.suppress) {
        this.$emit('timer');
      }
    }
  }
});

/***/ }),

/***/ 565:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CommonPanelView: __webpack_require__(979),
    DocNameDialog: __webpack_require__(475),
    DocsSidebarContainer: __webpack_require__(476)
  },
  data: function data() {
    return {
      renameStatus: false,
      currentDocName: '',
      menuActive: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    isAuthorized: function isAuthorized(state) {
      return state.isAuthorized;
    },
    profileName: function profileName(state) {
      return state.profileName;
    },
    docName: function docName(state) {
      return state.docName;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['renameDoc']), {
    rename: function rename() {
      this.currentDocName = this.docName;
      this.renameStatus = true;
      this.$refs.dialog.open();
    },
    performRename: function performRename() {
      this.renameDoc({ oldDocName: this.docName, newDocName: this.currentDocName });
    },
    openMenu: function openMenu() {
      this.$refs.docsSidebar.open();
    }
  })
});

/***/ }),

/***/ 566:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    docName: String,
    login: String,
    isAuthorized: Boolean,
    profileName: String
  }
});

/***/ }),

/***/ 567:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CountersBlock'
});

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: String,
    confirmText: {
      type: String,
      default: 'Переименовать'
    }
  },
  methods: {
    open: function open() {
      this.$refs.dialog.open();
    },
    close: function close(button) {
      if (button === 'ok') {
        this.$emit('confirm');
      }
    }
  }
});

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DocsSidebarContainer',
  components: {
    SidebarView: __webpack_require__(985),
    DocNameDialog: __webpack_require__(475)
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    docs: function docs(state) {
      return state.docs;
    }
  }), {
    itemsList: function itemsList() {
      return this.docs.map(function (doc) {
        return {
          name: doc.name
        };
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['loadDoc', 'createDoc']), {
    open: function open() {
      this.$refs.sidebar.toggleExpandState(true);
    },
    close: function close() {
      this.$refs.sidebar.toggleExpandState(false);
    },
    performDocCreate: function performDocCreate() {
      this.createDoc(this.currentDocName);
      this.loadDoc(this.currentDocName);
    },
    onCommonAction: function onCommonAction(actionKey) {
      if (actionKey === 'create') {
        this.$refs.dialog.open();
      }
    },
    onItemAction: function onItemAction(actionKey, item) {
      if (actionKey === 'open') {
        this.loadDoc(item.name);
        this.close();
      }
    }
  }),
  data: function data() {
    return {
      currentDocName: '',
      itemActions: [{
        key: 'open',
        name: 'Открыть',
        icon: 'open_in_browser'
      }, {
        key: 'delete',
        name: 'Удалить',
        icon: 'delete'
      }],
      commonActions: [{
        key: 'create',
        name: 'Новый документ',
        icon: 'add_box'
      }]
    };
  }
});

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LitListItemView: __webpack_require__(477)
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({ content: function content(state) {
      return state.contentHtml;
    } }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapGetters */])(['orderedSources'])),
  data: function data() {
    return {
      formatSources: false,
      format: 'pdf',
      contentWithSource: ''
    };
  },

  methods: {
    exportSources: function exportSources() {
      var result = [];
      var elements = this.$refs.sources.children;
      for (var i = 0; i < elements.length; i++) {
        result.push('<p>' + __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.escape(elements[i].innerText) + '</p>');
      }
      return result.join('');
    },
    export: function _export(format) {
      var _this = this;

      this.format = format;
      this.formatSources = true;
      this.$nextTick(function () {
        _this.$nextTick(function () {
          _this.contentWithSource = _this.content + _this.exportSources();
          _this.$nextTick(function () {
            _this.$refs.form.submit();
            _this.formatSources = false;
          });
        });
      });
    }
  }
});

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CountersBlock_vue__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CountersBlock_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CountersBlock_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FooterBar',
  components: {
    CountersBlock: __WEBPACK_IMPORTED_MODULE_0__components_CountersBlock_vue___default.a
  },
  data: function data() {
    return {
      links: [{
        title: 'О проекте',
        page: 'about'
      }, {
        title: 'Вопросы и ответы',
        page: 'faq'
      }, {
        title: 'Отзывы и предложения',
        link: 'http://art-jump.reformal.ru/proj/'
      }, {
        title: 'Генератор ссылок',
        page: 'simple'
      }, {
        title: 'Редактор статей (пробная версия)',
        page: 'editor'
      }]
    };
  }
});

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    textSize: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 26
    }
  },
  methods: {
    generate: function generate(text) {
      var context = this.$refs.canvas.getContext('2d');
      context.font = this.textSize + 'px serif';
      context.canvas.width = context.measureText(text).width;
      context.canvas.height = this.height;
      context.font = this.textSize + 'px serif';
      context.fillText(text, 0, this.textSize - 3);
      return context.canvas.toDataURL();
    }
  }
});

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(41);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LitListView: __webpack_require__(984)
  },
  props: {
    sources: Object
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["d" /* mapGetters */])(['orderedSources']), {
    sortedSources: function sortedSources() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sortBy(this.sourcesList, function (s) {
        return s.number ? s.number : 9999;
      });
    },
    sourcesList: function sourcesList() {
      var _this = this;

      var result = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.sources).forEach(function (id) {
        result.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.sources[id], { id: id }));
      });
      return result;
    }
  })
});

/***/ }),

/***/ 574:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vocabularies_accessModes_js__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_linkFormat_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
  filters: {
    capitalize: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.capitalize
  },
  computed: {
    formattedLink: function formattedLink() {
      if (this.content) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_linkFormat_js__["a" /* default */])(this.content);
      } else {
        return '';
      }
    },
    firstAuthor: function firstAuthor() {
      if (this.content && this.content.authors && this.content.authors[0]) {
        return this.content.authors[0];
      } else {
        return null;
      }
    },
    accessModeTitle: function accessModeTitle() {
      var _this = this;

      if (this.content.accessMode) {
        var value = __WEBPACK_IMPORTED_MODULE_1__vocabularies_accessModes_js__["a" /* default */].find(function (am) {
          return am.key === _this.content.accessMode;
        });
        if (value) {
          return value.title;
        }
      }
      return null;
    },
    accessDateTitle: function accessDateTitle() {
      if (this.content.accessDate) {
        var dateValue = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.content.accessDate, 'YYYY-MM-DD');
        if (dateValue) {
          return dateValue.format('DD.MM.YYYY');
        }
      }
      return null;
    }
  },
  methods: {
    onRemove: function onRemove() {
      this.$emit('remove', this.content);
    },
    getContent: function getContent() {
      return this.$refs.element.innerHTML;
    }
  },
  props: {
    content: Object,
    label: String,
    showLabel: {
      type: Boolean,
      default: true
    }
  }
});

/***/ }),

/***/ 575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Item: __webpack_require__(477)
  },
  props: {
    items: Array
  }
});

/***/ }),

/***/ 576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Expandable_js__ = __webpack_require__(549);



/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Expandable_js__["a" /* default */]],
  props: {
    visible: Boolean,
    title: String,
    list: Array,
    itemActions: Array,
    commonActions: Array,
    itemKeyField: String
  },
  methods: {
    onCommonAction: function onCommonAction(actionKey) {
      this.$emit('common-action', actionKey);
    },
    onItemAction: function onItemAction(actionKey, item) {
      this.$emit('item-action', actionKey, item);
    }
  }
});

/***/ }),

/***/ 577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_defaults_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SourceDialogForm_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_SourceDialogForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_SourceDialogForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_linkFormat__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseTextCopy_vue__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_BaseTextCopy_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_BaseTextCopy_vue__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SimpleListContainer',

  components: {
    SourceDialogForm: __WEBPACK_IMPORTED_MODULE_1__components_SourceDialogForm_vue___default.a,
    BaseTextCopy: __WEBPACK_IMPORTED_MODULE_3__components_BaseTextCopy_vue___default.a
  },

  computed: {
    formattedLink: function formattedLink() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_linkFormat__["a" /* default */])(this.content);
    }
  },

  data: function data() {
    return {
      content: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_defaults_js__["a" /* getDefaultSourceData */])()
    };
  }
});

/***/ }),

/***/ 578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_defaults_js__ = __webpack_require__(101);










/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SourceDialogView: __webpack_require__(991)
  },
  props: {},
  data: function data() {
    return {
      visible: false,
      action: null,
      content: null,
      editSourceId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    links: function links(state) {
      return state.links;
    },
    sources: function sources(state) {
      return state.sources;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['addSource', 'addLink', 'editSource']), {
    reset: function reset() {
      this.content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_defaults_js__["a" /* getDefaultSourceData */])();
    },
    add: function add() {
      this.action = 'add';
      this.content = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_defaults_js__["a" /* getDefaultSourceData */])();

      this.open();
    },
    edit: function edit(linkId) {
      this.action = 'edit';
      var link = this.links[linkId];

      this.editSourceId = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.head(link.sources);
      var source = this.sources[this.editSourceId];
      this.content = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.cloneDeep(source);

      this.open();
    },
    open: function open() {
      var _this = this;

      this.visible = true;
      this.$nextTick(function () {
        _this.$refs.dialogView.open();
      });
    },
    setContent: function setContent(values) {
      this.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, values);
    },
    onAddComplete: function onAddComplete() {
      var _this2 = this;

      this.addSource({ content: this.content }).then(function (sourceId) {
        return _this2.addLink({ sourceId: sourceId });
      }).then(function (linkId) {
        _this2.$emit('add-link', linkId);
      }).catch(function (err) {
        _this2.handleError(err);
      });
    },
    onEditComplete: function onEditComplete() {
      var _this3 = this;

      this.editSource({ content: this.content, sourceId: this.editSourceId }).catch(function (err) {
        _this3.handleError(err);
      });
    }
  })
});

/***/ }),

/***/ 579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_defaults_js__ = __webpack_require__(101);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SourceDialogCustom',
  props: {
    value: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setValue: function setValue(field, value) {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, field, value)));
    },
    setAuthorValue: function setAuthorValue(author, field, value) {
      this.setValue('authors', this.value.authors.map(function (currentAuthor) {
        if (author === currentAuthor) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, currentAuthor, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, field, value));
        } else {
          return currentAuthor;
        }
      }));
    },
    addAuthor: function addAuthor(author) {
      this.setValue('authors', [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.value.authors), [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__shared_defaults_js__["b" /* getDefaultAuthorData */])()]));
    },
    removeAuthor: function removeAuthor(author) {
      this.setValue('authors', _.without(this.value.authors, author));
    }
  }
});

/***/ }),

/***/ 580:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_resoucesRegexps_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SourceDialogExpandedHeader',

  props: {
    value: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      type: 'elibrary',
      elibraryLink: '',
      resourceLink: ''
    };
  },
  validations: function validations() {
    if (this.type === 'elibrary') {
      return {
        elibraryLink: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          pattern: function pattern(value) {
            return !!__WEBPACK_IMPORTED_MODULE_0__shared_resoucesRegexps_js__["a" /* elibraryRegExp */].test(value);
          }
        }
      };
    } else if (this.type === 'resource') {
      return {
        resourceLink: {
          required: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["required"],
          url: __WEBPACK_IMPORTED_MODULE_1_vuelidate_lib_validators__["url"]
        }
      };
    }
  },
  mounted: function mounted() {
    window.addEventListener('keydown', this.onKey);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.onKey);
  },


  methods: {
    prepare: function prepare() {
      if (this.type === 'resource' && this.resourceLink.indexOf('://') == -1) {
        this.resourceLink = 'http://' + this.resourceLink;
      }
    },
    ensureType: function ensureType(type) {
      var _this = this;

      if (this.type !== type) {
        this.type = type;
        if (type === 'elibrary') {
          this.$nextTick(function () {
            _this.$refs.elibraryInput.$el.focus();
          });
        } else if (type === 'resource') {
          this.$nextTick(function () {
            _this.$refs.resourceInput.$el.focus();
          });
        }
      }
    },
    onLoad: function onLoad() {
      this.prepare();
      this.$v.$touch();
      if (!this.$v.$error) {
        if (this.type === 'elibrary') {
          var id = this.elibraryLink.replace(__WEBPACK_IMPORTED_MODULE_0__shared_resoucesRegexps_js__["a" /* elibraryRegExp */], '$2');
          this.$emit('load-article', id);
        } else if (this.type === 'resource') {
          this.$emit('load-digital-resource', this.resourceLink);
        }
      }
    },
    onKey: function onKey(event) {
      if (event.keyCode == 13) {
        this.onLoad();
      }
    },
    onToggleCustom: function onToggleCustom() {
      this.$emit('toggle-custom');
    }
  }
});

/***/ }),

/***/ 581:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_defaults_js__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_elib_parser__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_elib_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_elib_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_pageinfo_js__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SourceDialogCustom_vue__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SourceDialogCustom_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__SourceDialogCustom_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SourceDialogHeader_vue__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SourceDialogHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__SourceDialogHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SourceDialogExpandedHeader_vue__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SourceDialogExpandedHeader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__SourceDialogExpandedHeader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_superagent__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_superagent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_superagent__);











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SourceDialogForm',

  components: {
    SourceDialogCustom: __WEBPACK_IMPORTED_MODULE_5__SourceDialogCustom_vue___default.a,
    SourceDialogHeader: __WEBPACK_IMPORTED_MODULE_6__SourceDialogHeader_vue___default.a,
    SourceDialogExpandedHeader: __WEBPACK_IMPORTED_MODULE_7__SourceDialogExpandedHeader_vue___default.a
  },

  props: {
    value: Object,
    dialogMode: {
      type: Boolean,
      default: true
    }
  },

  data: function data() {
    return {
      showCustom: this.dialogMode ? true : false,
      loading: false,
      link: ''
    };
  },


  methods: {
    setValue: function setValue(field, value) {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field, value)));
    },
    getElibraryArticle: function getElibraryArticle(id) {
      var _this = this;

      this.loading = true;
      var url = 'https://elibrary.ru/item.asp?id=' + id;
      __WEBPACK_IMPORTED_MODULE_8_superagent___default.a.get('/elibrary/start_session.asp').query({ rpage: url }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_3_elib_parser___default()({ 'url': '/elibrary' }).getArticle(id);
      }).then(function (sourceData) {
        _this.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_defaults_js__["a" /* getDefaultSourceData */])(), sourceData, {
          type: 'article',
          url: url
        }));
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.handleError(err);
      });
    },
    getDigitalResource: function getDigitalResource(url) {
      var _this2 = this;

      this.loading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__shared_pageinfo_js__["a" /* default */])(url).then(function (result) {
        var values = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__shared_defaults_js__["a" /* getDefaultSourceData */])(), {
          type: 'resource',
          url: url,
          title: result.name,
          source: result.source
        });
        _this2.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.value, values));
        _this2.loading = false;
      }).catch(function (err) {
        _this2.handleError(err);
        _this2.loading = false;
      });
    },
    onToggleCustom: function onToggleCustom() {
      this.showCustom = !this.showCustom;
    }
  }
});

/***/ }),

/***/ 582:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_resoucesRegexps_js__ = __webpack_require__(235);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SourceDialogHeader',
  props: {
    value: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      typeOptions: [{
        key: 'article',
        title: 'Статья'
      }, {
        key: 'book',
        title: 'Книга'
      }, {
        key: 'resource',
        title: 'Электронный ресурс'
      }]
    };
  },


  methods: {
    onLoadSource: function onLoadSource() {
      var value = this.value.url;
      if (__WEBPACK_IMPORTED_MODULE_2__shared_resoucesRegexps_js__["a" /* elibraryRegExp */].test(value)) {
        var id = value.replace(__WEBPACK_IMPORTED_MODULE_2__shared_resoucesRegexps_js__["a" /* elibraryRegExp */], '$2');
        this.$emit('load-article', id);
      } else {
        this.$emit('load-digital-resource', value);
      }
    },
    setValue: function setValue(field, value) {
      this.$emit('input', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.value, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, field, value)));
    }
  }
});

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SourceDialogForm_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SourceDialogForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SourceDialogForm_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'SourceDialogView',
  components: {
    SourceDialogForm: __WEBPACK_IMPORTED_MODULE_1__SourceDialogForm_vue___default.a
  },
  props: {
    content: Object,
    action: String
  },
  data: function data() {
    return {};
  },

  methods: {
    onCancel: function onCancel() {
      this.$refs.dialog.close();
      this.$emit('cancel');
    },
    onAdd: function onAdd() {
      this.$refs.dialog.close();
      this.$emit('add-complete');
    },
    onSave: function onSave() {
      this.$refs.dialog.close();
      this.$emit('edit-complete');
    },
    open: function open() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs.dialog.open();
      });
    },
    setContent: function setContent(values) {
      this.$emit('set-content', values);
    }
  }
});

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  methods: {
    onAction: function onAction(action) {
      this.$emit(action.action);
    }
  },
  props: {
    highlightSave: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    actions: function actions() {
      return [{
        action: 'open',
        visible: false,
        icon: 'move_to_inbox',
        title: 'Открыть'
      }, {
        action: 'save',
        icon: 'save',
        highlight: this.highlightSave,
        title: 'Сохранить'
      }, {
        action: 'export',
        icon: 'move_to_inbox',
        title: 'Экспорт в Word',
        separatorAfter: true
      }, {
        action: 'undo',
        icon: 'undo',
        title: 'Отмена'
      }, {
        action: 'redo',
        icon: 'redo',
        title: 'Повторить',
        separatorAfter: true
      }, {
        action: 'copy',
        icon: 'content_copy',
        title: 'Копировать'
      }, {
        action: 'cut',
        icon: 'content_cut',
        title: 'Вырезать'
      }, {
        action: 'paste',
        icon: 'content_paste',
        title: 'Вставить',
        separatorAfter: true
      }, {
        action: 'header',
        visible: true,
        icon: 'format_size',
        title: 'Заговок раздела'
      }, {
        action: 'list',
        icon: 'format_list_bulleted',
        title: 'Маркированный список'
      }, {
        action: 'add-source',
        icon: 'link',
        title: 'Ссылка на источник'
      }, {
        action: 'add-image',
        visible: false,
        icon: 'insert_photo',
        title: 'Вставка рисунка'
      }, {
        action: 'add-table',
        visible: false,
        icon: 'view_comfy',
        title: 'Вставка таблицы'
      }, {
        action: 'add-formula',
        visible: false,
        icon: 'functions',
        title: 'Вставка выражения'
      }, {
        action: 'add-listing',
        visible: false,
        icon: 'code',
        title: 'Вставка листинга'
      }];
    }
  }
});

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AboutPage',
  components: {
    FooterBar: __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue___default.a
  }
});

/***/ }),

/***/ 586:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    CommonBarContainer: __webpack_require__(978),
    ArticleContainer: __webpack_require__(973),
    FooterBar: __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue___default.a
  },
  methods: {
    auth: function auth() {
      this.$emit('auth');
    },
    logout: function logout() {
      this.$emit('logout');
    }
  }
});

/***/ }),

/***/ 587:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'FaqPage',
  components: {
    FooterBar: __WEBPACK_IMPORTED_MODULE_0__components_FooterBar_vue___default.a
  }
});

/***/ }),

/***/ 588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SimpleListContainer_vue__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_SimpleListContainer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_SimpleListContainer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterBar_vue__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FooterBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FooterBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AdBlock_vue__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AdBlock_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_AdBlock_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ListPage',
  components: {
    AdBlock: __WEBPACK_IMPORTED_MODULE_2__components_AdBlock_vue___default.a,
    SimpleListContainer: __WEBPACK_IMPORTED_MODULE_0__components_SimpleListContainer_vue___default.a,
    FooterBar: __WEBPACK_IMPORTED_MODULE_1__components_FooterBar_vue___default.a
  }
});

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

module.exports = {"name":"cheerio","version":"1.0.0-rc.2","description":"Tiny, fast, and elegant implementation of core jQuery designed specifically for the server","author":"Matt Mueller <mattmuelle@gmail.com> (mat.io)","license":"MIT","keywords":["htmlparser","jquery","selector","scraper","parser","html"],"repository":{"type":"git","url":"git://github.com/cheeriojs/cheerio.git"},"main":"./index.js","files":["index.js","lib"],"engines":{"node":">= 0.6"},"dependencies":{"css-select":"~1.2.0","dom-serializer":"~0.1.0","entities":"~1.1.1","htmlparser2":"^3.9.1","lodash":"^4.15.0","parse5":"^3.0.1"},"devDependencies":{"benchmark":"^2.1.0","coveralls":"^2.11.9","expect.js":"~0.3.1","istanbul":"^0.4.3","jquery":"^3.0.0","jsdom":"^9.2.1","jshint":"^2.9.2","mocha":"^3.1.2","xyz":"~1.1.0"},"scripts":{"test":"make test"},"_resolved":"https://registry.npmjs.org/cheerio/-/cheerio-1.0.0-rc.2.tgz","_integrity":"sha1-S59TqBsn5NXawxwP/Qz6A8xoMNs=","_from":"cheerio@1.0.0-rc.2"}

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = {"name":"cheerio","version":"0.22.0","description":"Tiny, fast, and elegant implementation of core jQuery designed specifically for the server","author":"Matt Mueller <mattmuelle@gmail.com> (mat.io)","license":"MIT","keywords":["htmlparser","jquery","selector","scraper","parser","html"],"repository":{"type":"git","url":"git://github.com/cheeriojs/cheerio.git"},"main":"./index.js","files":["index.js","lib"],"engines":{"node":">= 0.6"},"dependencies":{"css-select":"~1.2.0","dom-serializer":"~0.1.0","entities":"~1.1.1","htmlparser2":"^3.9.1","lodash.assignin":"^4.0.9","lodash.bind":"^4.1.4","lodash.defaults":"^4.0.1","lodash.filter":"^4.4.0","lodash.flatten":"^4.2.0","lodash.foreach":"^4.3.0","lodash.map":"^4.4.0","lodash.merge":"^4.4.0","lodash.pick":"^4.2.1","lodash.reduce":"^4.4.0","lodash.reject":"^4.4.0","lodash.some":"^4.4.0"},"devDependencies":{"benchmark":"^2.1.0","coveralls":"^2.11.9","expect.js":"~0.3.1","istanbul":"^0.4.3","jsdom":"^9.2.1","jquery":"^3.0.0","jshint":"^2.9.2","mocha":"^2.5.3","xyz":"~0.5.0"},"scripts":{"test":"make test"},"_resolved":"http://registry.npmjs.org/cheerio/-/cheerio-0.22.0.tgz","_integrity":"sha1-qbqoYKP5tZWmuBsahocxIe06Jp4=","_from":"cheerio@0.22.0"}

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

module.exports = {"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 677:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 678:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 680:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 682:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 688:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 841:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 303,
	"./af.js": 303,
	"./ar": 310,
	"./ar-dz": 304,
	"./ar-dz.js": 304,
	"./ar-kw": 305,
	"./ar-kw.js": 305,
	"./ar-ly": 306,
	"./ar-ly.js": 306,
	"./ar-ma": 307,
	"./ar-ma.js": 307,
	"./ar-sa": 308,
	"./ar-sa.js": 308,
	"./ar-tn": 309,
	"./ar-tn.js": 309,
	"./ar.js": 310,
	"./az": 311,
	"./az.js": 311,
	"./be": 312,
	"./be.js": 312,
	"./bg": 313,
	"./bg.js": 313,
	"./bm": 314,
	"./bm.js": 314,
	"./bn": 315,
	"./bn.js": 315,
	"./bo": 316,
	"./bo.js": 316,
	"./br": 317,
	"./br.js": 317,
	"./bs": 318,
	"./bs.js": 318,
	"./ca": 319,
	"./ca.js": 319,
	"./cs": 320,
	"./cs.js": 320,
	"./cv": 321,
	"./cv.js": 321,
	"./cy": 322,
	"./cy.js": 322,
	"./da": 323,
	"./da.js": 323,
	"./de": 326,
	"./de-at": 324,
	"./de-at.js": 324,
	"./de-ch": 325,
	"./de-ch.js": 325,
	"./de.js": 326,
	"./dv": 327,
	"./dv.js": 327,
	"./el": 328,
	"./el.js": 328,
	"./en-au": 329,
	"./en-au.js": 329,
	"./en-ca": 330,
	"./en-ca.js": 330,
	"./en-gb": 331,
	"./en-gb.js": 331,
	"./en-ie": 332,
	"./en-ie.js": 332,
	"./en-il": 333,
	"./en-il.js": 333,
	"./en-nz": 334,
	"./en-nz.js": 334,
	"./eo": 335,
	"./eo.js": 335,
	"./es": 338,
	"./es-do": 336,
	"./es-do.js": 336,
	"./es-us": 337,
	"./es-us.js": 337,
	"./es.js": 338,
	"./et": 339,
	"./et.js": 339,
	"./eu": 340,
	"./eu.js": 340,
	"./fa": 341,
	"./fa.js": 341,
	"./fi": 342,
	"./fi.js": 342,
	"./fo": 343,
	"./fo.js": 343,
	"./fr": 346,
	"./fr-ca": 344,
	"./fr-ca.js": 344,
	"./fr-ch": 345,
	"./fr-ch.js": 345,
	"./fr.js": 346,
	"./fy": 347,
	"./fy.js": 347,
	"./gd": 348,
	"./gd.js": 348,
	"./gl": 349,
	"./gl.js": 349,
	"./gom-latn": 350,
	"./gom-latn.js": 350,
	"./gu": 351,
	"./gu.js": 351,
	"./he": 352,
	"./he.js": 352,
	"./hi": 353,
	"./hi.js": 353,
	"./hr": 354,
	"./hr.js": 354,
	"./hu": 355,
	"./hu.js": 355,
	"./hy-am": 356,
	"./hy-am.js": 356,
	"./id": 357,
	"./id.js": 357,
	"./is": 358,
	"./is.js": 358,
	"./it": 359,
	"./it.js": 359,
	"./ja": 360,
	"./ja.js": 360,
	"./jv": 361,
	"./jv.js": 361,
	"./ka": 362,
	"./ka.js": 362,
	"./kk": 363,
	"./kk.js": 363,
	"./km": 364,
	"./km.js": 364,
	"./kn": 365,
	"./kn.js": 365,
	"./ko": 366,
	"./ko.js": 366,
	"./ky": 367,
	"./ky.js": 367,
	"./lb": 368,
	"./lb.js": 368,
	"./lo": 369,
	"./lo.js": 369,
	"./lt": 370,
	"./lt.js": 370,
	"./lv": 371,
	"./lv.js": 371,
	"./me": 372,
	"./me.js": 372,
	"./mi": 373,
	"./mi.js": 373,
	"./mk": 374,
	"./mk.js": 374,
	"./ml": 375,
	"./ml.js": 375,
	"./mn": 376,
	"./mn.js": 376,
	"./mr": 377,
	"./mr.js": 377,
	"./ms": 379,
	"./ms-my": 378,
	"./ms-my.js": 378,
	"./ms.js": 379,
	"./mt": 380,
	"./mt.js": 380,
	"./my": 381,
	"./my.js": 381,
	"./nb": 382,
	"./nb.js": 382,
	"./ne": 383,
	"./ne.js": 383,
	"./nl": 385,
	"./nl-be": 384,
	"./nl-be.js": 384,
	"./nl.js": 385,
	"./nn": 386,
	"./nn.js": 386,
	"./pa-in": 387,
	"./pa-in.js": 387,
	"./pl": 388,
	"./pl.js": 388,
	"./pt": 390,
	"./pt-br": 389,
	"./pt-br.js": 389,
	"./pt.js": 390,
	"./ro": 391,
	"./ro.js": 391,
	"./ru": 392,
	"./ru.js": 392,
	"./sd": 393,
	"./sd.js": 393,
	"./se": 394,
	"./se.js": 394,
	"./si": 395,
	"./si.js": 395,
	"./sk": 396,
	"./sk.js": 396,
	"./sl": 397,
	"./sl.js": 397,
	"./sq": 398,
	"./sq.js": 398,
	"./sr": 400,
	"./sr-cyrl": 399,
	"./sr-cyrl.js": 399,
	"./sr.js": 400,
	"./ss": 401,
	"./ss.js": 401,
	"./sv": 402,
	"./sv.js": 402,
	"./sw": 403,
	"./sw.js": 403,
	"./ta": 404,
	"./ta.js": 404,
	"./te": 405,
	"./te.js": 405,
	"./tet": 406,
	"./tet.js": 406,
	"./tg": 407,
	"./tg.js": 407,
	"./th": 408,
	"./th.js": 408,
	"./tl-ph": 409,
	"./tl-ph.js": 409,
	"./tlh": 410,
	"./tlh.js": 410,
	"./tr": 411,
	"./tr.js": 411,
	"./tzl": 412,
	"./tzl.js": 412,
	"./tzm": 414,
	"./tzm-latn": 413,
	"./tzm-latn.js": 413,
	"./tzm.js": 414,
	"./ug-cn": 415,
	"./ug-cn.js": 415,
	"./uk": 416,
	"./uk.js": 416,
	"./ur": 417,
	"./ur.js": 417,
	"./uz": 419,
	"./uz-latn": 418,
	"./uz-latn.js": 418,
	"./uz.js": 419,
	"./vi": 420,
	"./vi.js": 420,
	"./x-pseudo": 421,
	"./x-pseudo.js": 421,
	"./yo": 422,
	"./yo.js": 422,
	"./zh-cn": 423,
	"./zh-cn.js": 423,
	"./zh-hk": 424,
	"./zh-hk.js": 424,
	"./zh-tw": 425,
	"./zh-tw.js": 425
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 841;

/***/ }),

/***/ 972:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(675)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1001),
  /* scopeId */
  "data-v-2fcb14d8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(997),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(677)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1004),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 975:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(680)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1009),
  /* scopeId */
  "data-v-5a196660",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(692)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1027),
  /* scopeId */
  "data-v-ed8fdc16",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1020),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(674)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(565),
  /* template */
  __webpack_require__(999),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(688)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(566),
  /* template */
  __webpack_require__(1021),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 980:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(567),
  /* template */
  __webpack_require__(1000),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(570),
  /* template */
  __webpack_require__(1003),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 982:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(572),
  /* template */
  __webpack_require__(1014),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 983:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(573),
  /* template */
  __webpack_require__(1024),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 984:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(575),
  /* template */
  __webpack_require__(1011),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 985:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(687)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(576),
  /* template */
  __webpack_require__(1019),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(678)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(577),
  /* template */
  __webpack_require__(1007),
  /* scopeId */
  "data-v-4af241c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 987:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(578),
  /* template */
  __webpack_require__(1006),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(673)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(579),
  /* template */
  __webpack_require__(998),
  /* scopeId */
  "data-v-0fd10856",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(685)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(580),
  /* template */
  __webpack_require__(1016),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(582),
  /* template */
  __webpack_require__(1005),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 991:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(686)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(583),
  /* template */
  __webpack_require__(1017),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(682)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(584),
  /* template */
  __webpack_require__(1012),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(676)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(585),
  /* template */
  __webpack_require__(1002),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(683)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(586),
  /* template */
  __webpack_require__(1013),
  /* scopeId */
  "data-v-68b74694",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(684)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(587),
  /* template */
  __webpack_require__(1015),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 996:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(679)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(588),
  /* template */
  __webpack_require__(1008),
  /* scopeId */
  "data-v-57c6f271",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 997:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-wrapper"
  }, [_c('docs-sidebar-container'), _vm._v(" "), _c('toolbar-view', {
    attrs: {
      "highlight-save": !_vm.docSaved
    },
    on: {
      "export": function($event) {
        _vm.onExport('doc')
      },
      "save": _vm.onSave,
      "open": _vm.onLoad,
      "undo": function($event) {
        _vm.onEditorAction('editorUndo')
      },
      "redo": function($event) {
        _vm.onEditorAction('editorRedo')
      },
      "copy": function($event) {
        _vm.onEditorAction('editorCopy')
      },
      "cut": function($event) {
        _vm.onEditorAction('editorCut')
      },
      "paste": function($event) {
        _vm.onEditorAction('editorPaste')
      },
      "header": function($event) {
        _vm.onEditorAction('editorHeader')
      },
      "list": function($event) {
        _vm.onEditorAction('editorList')
      },
      "add-source": _vm.openAddSourceDialog
    }
  }), _vm._v(" "), _c('article-view', {
    ref: "editor",
    attrs: {
      "links": _vm.linksLabels,
      "content-html": _vm.contentHtml
    },
    on: {
      "input": _vm.onChangeContent,
      "add-source": _vm.openAddSourceDialog,
      "edit-link": _vm.onEditLink,
      "set-doc-name": _vm.onSetDocName,
      "export": _vm.onExport
    }
  }, [_c('lit-list-container', {
    attrs: {
      "slot": "lit-list",
      "sources": _vm.sources
    },
    slot: "lit-list"
  })], 1), _vm._v(" "), _c('export-container', {
    ref: "exportContainer"
  }), _vm._v(" "), _c('source-dialog-container', {
    ref: "sourceDialog",
    on: {
      "add-link": _vm.onAddLink
    }
  }), _vm._v(" "), _c('base-timer', {
    attrs: {
      "timeout": 5000
    },
    on: {
      "timer": _vm.onSaveTimer
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 998:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "source-dialog-custom"
  }, [_c('md-input-container', [_c('label', [_vm._v("Название")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.value.title,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('title', arguments[0])
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "authors"
  }, [_vm._l((_vm.value.authors), function(author) {
    return _c('div', {
      staticClass: "author-item"
    }, [_c('md-input-container', [_c('label', [_vm._v("Фамилия")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "value": author.lastName,
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          _vm.setAuthorValue(author, 'lastName', arguments[0])
        }
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "first-name"
    }, [_c('label', [_vm._v("Имя (первая буква)")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "value": author.firstNameInitial,
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          _vm.setAuthorValue(author, 'firstNameInitial', arguments[0])
        }
      }
    })], 1), _vm._v(" "), _c('md-input-container', {
      staticClass: "extra-name"
    }, [_c('label', [_vm._v("Отчество (первая буква)")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "value": author.extraNameInitial,
        "disabled": _vm.disabled
      },
      on: {
        "input": function($event) {
          _vm.setAuthorValue(author, 'extraNameInitial', arguments[0])
        }
      }
    })], 1), _vm._v(" "), _c('md-button', {
      on: {
        "click": function($event) {
          _vm.removeAuthor(author)
        }
      }
    }, [_c('md-icon', [_vm._v("close")]), _vm._v(" "), _c('md-tooltip', [_vm._v("Удалить автора")])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "authors-actions"
  }, [_c('md-button', {
    staticClass: "md-raised",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.addAuthor
    }
  }, [_vm._v("Добавить автора")])], 1)], 2), _vm._v(" "), (_vm.value.type === 'article') ? _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Год")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.value.year,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('year', arguments[0])
      }
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Выпуск")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.value.issue,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('issue', arguments[0])
      }
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Страницы")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "value": _vm.value.pages,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('pages', arguments[0])
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.value.type === 'resource') ? _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Адрес страницы")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "value": _vm.value.url,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('url', arguments[0])
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Наименование источника")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "text",
      "value": _vm.value.source,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('source', arguments[0])
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.value.type === 'resource') ? _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Режим доступа")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "value": _vm.value.accessMode,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('accessMode', arguments[0])
      }
    }
  }, [_c('md-option', {
    attrs: {
      "value": "free"
    }
  }, [_vm._v("Свободный")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "authorize"
    }
  }, [_vm._v("Требуется авторизация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.value.type === 'resource') ? _c('div', {
    staticClass: "group"
  }, [_c('md-input-container', [_c('label', [_vm._v("Дата обращеня")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "date",
      "value": _vm.value.accessDate,
      "disabled": _vm.disabled
    },
    on: {
      "input": function($event) {
        _vm.setValue('accessDate', arguments[0])
      }
    }
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-panel-container"
  }, [_c('docs-sidebar-container', {
    ref: "docsSidebar"
  }), _vm._v(" "), _c('common-panel-view', {
    attrs: {
      "is-authorized": _vm.isAuthorized,
      "profile-name": _vm.profileName,
      "doc-name": _vm.docName
    },
    on: {
      "login": function($event) {
        _vm.$emit('login')
      },
      "logout": function($event) {
        _vm.$emit('logout')
      },
      "open-menu": _vm.openMenu,
      "rename": _vm.rename
    }
  }), _vm._v(" "), _c('doc-name-dialog', {
    ref: "dialog",
    on: {
      "confirm": _vm.performRename
    },
    model: {
      value: (_vm.currentDocName),
      callback: function($$v) {
        _vm.currentDocName = $$v
      },
      expression: "currentDocName"
    }
  })], 1)
},staticRenderFns: []}

/***/ })

},[548]);


// WEBPACK FOOTER //
// static/js/app.a63a5ffff266b46f0006.js